// src/javascript/playback-hub.ts
const hub = new EventTarget();

export const EVT_PLAYBACK = "playback";

export function announcePlayback(key: string) {
	hub.dispatchEvent(new CustomEvent(EVT_PLAYBACK, { detail: { key } }));
}

export function onHub<T extends Event>(
	type: string,
	handler: (e: T) => void
) {
	const wrapped = handler as EventListener;
	hub.addEventListener(type, wrapped);
	return () => hub.removeEventListener(type, wrapped);
}
